const $$splitComponentImporter = () => import('/home/runner/work/graph-it/graph-it/apps/graphit/src/routes/_authed/cartographies/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authed/cartographies')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});